import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import SmoothScroll from "./SmoothScroll";
import CookieBanner from "./CookieBanner";
import { onConsentMaybeInit } from "../lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AnalyticsBootstrap() {
  useEffect(() => {
    onConsentMaybeInit();
  }, []);
  return null;
}

export default function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-warm-white text-stone2-dark antialiased">
        <a href="#main" className="skip-link">
          Vai al contenuto
        </a>
        <ScrollToTop />
        <AnalyticsBootstrap />
        <Nav />
        <main id="main">{children}</main>
        <Footer />
        <CookieBanner />
      </div>
    </SmoothScroll>
  );
}
